module.exports = __webpack_public_path__ + "img/USDJPY.3a1e23fd.png";